import { useIntl } from 'react-intl';

import { LegacyButton } from '@/components/LegacyButton';
import type { OrderAppCtaType } from '@/graphql/orderApp/api';
import { commonMessages } from '@/messages/common';

export const CTAForStrapPack = ({
  cta,
  onClick,
}: {
  cta?: OrderAppCtaType;
  onClick?: () => void;
}) => {
  const { formatMessage } = useIntl();
  let label;
  if (cta === 'ORDER' || cta === 'PRE_ORDER') {
    label = formatMessage(commonMessages.select);
  } else {
    label = formatMessage(commonMessages.contactUs);
  }
  return <LegacyButton isFluid label={label} onClick={onClick} />;
};
